const CAROUSEL_ITEMS = [
  {
    id: 'cr1',
    title: '某顶流明星疑似恋情曝光',
    desc: '近日有网友拍到某顶流明星与神秘异性亲密同框，引发全网热议。粉丝群体反应激烈，工作室暂未回应。事件持续发酵中…',
    image: 'https://readdy.ai/api/search-image?query=Modern%20stylized%20illustration%20of%20celebrity%20paparazzi%20night%20scene%20with%20silhouettes%20and%20flashing%20cameras%2C%20warm%20dramatic%20lighting%2C%20editorial%20magazine%20style%2C%20soft%20focus%20background%20with%20city%20lights%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20clean%20composition&width=800&height=500&seq=carousel-item-01&orientation=landscape',
    tag: '娱乐圈',
  },
  {
    id: 'cr2',
    title: '千万粉网红直播翻车名场面',
    desc: '某千万粉大主播在最新直播中意外翻车，产品演示出现严重失误，弹幕瞬间刷屏，相关话题迅速登上多个平台热搜。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20live%20streaming%20studio%20with%20dramatic%20red%20alert%20lighting%2C%20abstract%20social%20media%20comment%20bubbles%20floating%2C%20modern%20minimalist%20design%20with%20warm%20coral%20accents%2C%20editorial%20style%20digital%20art%2C%20no%20text%2C%20clean%20aesthetic&width=800&height=500&seq=carousel-item-02&orientation=landscape',
    tag: '直播',
  },
  {
    id: 'cr3',
    title: '全网热搜第一：某知名企业被曝',
    desc: '一篇匿名爆料将某知名企业推上风口浪尖，涉及职场文化与内部管理问题。多条相关话题霸占热搜榜，舆论持续升温。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20corporate%20building%20silhouette%20with%20dramatic%20warm%20amber%20and%20coral%20sky%2C%20newspaper%20headlines%20floating%20as%20abstract%20shapes%2C%20editorial%20style%20with%20soft%20gradients%2C%20professional%20yet%20dynamic%20composition%2C%20no%20text&width=800&height=500&seq=carousel-item-03&orientation=landscape',
    tag: '社会',
  },
  {
    id: 'cr4',
    title: '年度情感大瓜：当红夫妻官宣分手',
    desc: '娱乐圈知名夫妻档突然宣布结束多年婚姻，声明措辞引发各方解读。网友迅速扒出此前各种蛛丝马迹，吃瓜群众集体上阵分析时间线。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20artistic%20illustration%20of%20two%20figures%20walking%20apart%20in%20warm%20twilight%20cityscape%2C%20soft%20dramatic%20lighting%20with%20coral%20and%20amber%20gradients%2C%20emotional%20editorial%20style%2C%20minimalist%20composition%2C%20clean%20modern%20aesthetic%2C%20no%20text&width=800&height=500&seq=carousel-item-04&orientation=landscape',
    tag: '情感',
  },
  {
    id: 'cr5',
    title: '科技圈大地震：AI巨头突发争议',
    desc: '某AI行业领军企业在产品发布会上引发巨大争议，涉及数据隐私与伦理问题。科技圈、法律界、自媒体三方激烈论战，事件影响持续扩大。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20illustration%20of%20digital%20technology%20and%20data%20visualization%20with%20warm%20coral%20and%20golden%20tones%2C%20futuristic%20interface%20elements%20blending%20with%20editorial%20news%20aesthetic%2C%20clean%20minimalist%20design%2C%20dynamic%20composition%2C%20no%20text&width=800&height=500&seq=carousel-item-05&orientation=landscape',
    tag: '科技',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          焦点追踪
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          本周最受关注的网络热门事件
        </p>
        <div className="flex flex-col gap-5">
          {CAROUSEL_ITEMS.map((item) => (
            <a
              key={item.id}
              href="#cards"
              className="bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group flex flex-col md:flex-row"
            >
              <div className="md:w-64 lg:w-80 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-48 md:h-full object-cover"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col justify-center flex-1">
                <span className="inline-block bg-primary-100 text-primary-700 text-xs font-medium px-2.5 py-1 rounded-full mb-3 w-fit whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium mt-3">
                  查看详情 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}